import { useLocale } from 'next-intl';
import Image from 'next/image';
import { cn } from '@/lib/utils';

/**
 * Brand lockups — wordmark differs per locale (kasbly / كسبلي).
 * `light` is the cream+gold knockout for dark/green surfaces (footer).
 */
const LOCKUPS = {
  en: {
    default: { src: '/kasbly-lockup-en.png', width: 575, height: 160 },
    light: { src: '/kasbly-lockup-en-light.webp', width: 626, height: 160 },
  },
  ar: {
    default: { src: '/kasbly-lockup-ar.png', width: 650, height: 160 },
    light: { src: '/kasbly-lockup-ar-light.webp', width: 640, height: 160 },
  },
} as const;

/** Locale-aware horizontal lockup (mark + wordmark). Size via className (h-* w-auto). */
export function Logo({
  className,
  variant = 'default',
}: {
  className?: string;
  /** "light" = cream+gold knockout for dark surfaces. */
  variant?: 'default' | 'light';
}) {
  const locale = useLocale();
  const { src, width, height } = LOCKUPS[locale === 'ar' ? 'ar' : 'en'][variant];
  return (
    <Image
      src={src}
      alt="Kasbly"
      width={width}
      height={height}
      className={cn('h-8 w-auto', className)}
      priority
    />
  );
}

/** Square mark only — for solid-green surfaces (footer) and tight spots. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <Image
      src="/kasbly-mark.png"
      alt=""
      width={165}
      height={160}
      className={cn('h-8 w-auto', className)}
    />
  );
}
